import { render, staticRenderFns } from "./IgmpRouter.vue?vue&type=template&id=441fea4e&"
import script from "./IgmpRouter.vue?vue&type=script&lang=js&"
export * from "./IgmpRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports